import { useMemo } from 'react';
import { useWizard } from '../WizardProvider';
import WizardShell from '../WizardShell';
import ProductAccordionTree from '../components/ProductAccordionTree';
import { buildProductTree } from '../components/productTree';
import { useProducts } from '../../../../hooks/useProducts';
import { STEP3_INSTRUCTION } from '../copy';

export default function Step3Products({ onExit }: { onExit: () => void }) {
  const { state, dispatch } = useWizard();
  const { data } = useProducts();
  // data is undefined while the query is loading; buildProductTree requires an array. An empty
  // list still renders the three collapsed accordions, which is what should show while loading —
  // no separate spinner/skeleton state.
  const tree = useMemo(() => buildProductTree(data ?? []), [data]);

  return (
    <WizardShell title="Products" canAdvance onExit={onExit}>
      <section>
        <h2 className="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-1">Product Setup</h2>
        <p className="text-sm text-gray-500 dark:text-gray-400 mb-4">{STEP3_INSTRUCTION}</p>
        <ProductAccordionTree
          tree={tree}
          selected={state.products}
          onToggle={(urn) => dispatch({ type: 'toggleProduct', urn })}
        />
      </section>
    </WizardShell>
  );
}
